export const FETCH_AVAIL_CREDIT = 'FETCH_AVAIL_CREDIT';
export const AVAILCRDIT_SUCCESS = 'AVAILCRDIT_SUCCESS';
export const AVAILCRDIT_ERROR = 'AVAILCRDIT_ERROR';

export const REQ_CREDIT = 'REQ_CREDIT';
export const REQ_CREDIT_SUCCESS = 'REQ_CREDIT_SUCCESS';
export const REQ_CREDIT_ERROR = 'REQ_CREDIT_ERROR';

export const CANCEL_ENROLL = 'CANCEL_ENROLL';
export const CANCEL_ENROLL_SUCCESS = 'CANCEL_ENROLL_SUCCESS';
export const CANCEL_ENROLL_ERROR = 'CANCEL_ENROLL_ERROR';

export const ENROLLMENT_CODE = 'ENROLLMENT_CODE';
export const ENROLLMENT_CODE_SUCCESS = 'ENROLLMENT_CODE_SUCCESS';
export const ENROLLMENT_CODE_ERROR = 'ENROLLMENT_CODE_ERROR';
